import './home.scss'
import { createContext, useState } from 'react'
import { Product } from '../../types/types_product'
import { Product_2 } from '../../types/types_product_2'
import Background from '../../components/Background/Background'
import FetchProductsData from '../../components/FetchProductsData/FetchProductsData'
import ProductsList from '../../components/ProductsList/ProductsList'
import { profileData } from "../../data/data"

interface ProductsDataContextType {
   productsData: (Product | Product_2)[];
   setProductsData: React.Dispatch<React.SetStateAction<(Product | Product_2)[]>>;
}

export const ProductsDataContext = createContext<ProductsDataContextType | undefined>(undefined);

function Home() {
   const [productsData, setProductsData] = useState<(Product | Product_2)[]>([]);

   return (
      <section className='home' >
         <ProductsDataContext.Provider value={{ productsData, setProductsData }}>
            <FetchProductsData />
            <Background />
            <ProductsList store_url={profileData.whereToBuy.location.url} />
         </ProductsDataContext.Provider>
      </section >
   )
}

export default Home